export default __webpack_public_path__ + "static/media/ClinicalTrials.icon.2e347f78.svg";